import React from "react";

class WordpressMobile extends React.Component {
  state = {
    isDroppedDown: false,
    waitTimer: 3000,
  };

  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({
      isDroppedDown: !this.state.isDroppedDown,
    });
  }

  render() {
    return (
      <ul className="mobile-apps-list">
        {typeof this.props.school !== "undefined" &&
          this.props.school.sc_wordpress_url !== "" && (
            <li className="main-apps__app-icon">
              <a
                href={
                  this.props.school.sc_wordpress_url +
                  (this.wordpress === 4 ? "/wordpress" : "") +
                  "/wp-admin"
                }
                target="_blank"
                rel="noopener noreferrer"
                alt="app"
                className=""
              >
                <img
                  alt="Wordpress Dashboard Icon"
                  src="https://cdn.realsmart.co.uk/new-cpanel/wordpress_icon.png"
                  className="app-icon app-icon-gmail"
                />
                <span>Dashboard</span>
              </a>
            </li>
          )}
      </ul>
    );
  }
}

export default WordpressMobile;
